export default "__VITE_ASSET__325acc20__"